import React, { useState } from "react";
import icons from "../../datasets/icons";

interface Props {
	size?: string;
	className?: string;
	icon: string;
	onClick?: () => void;
}

const Icon: React.FC<Props> = ({ size, className, icon, onClick }) => {
	const [menu, setMenu] = useState<any>({ show: false });
	return (
		<span
			onClick={() => {
				if (onClick) onClick();
			}}
			className={"icon-" + size + " " + className}
			dangerouslySetInnerHTML={{ __html: icons(icon) }}
		></span>
	);
};

export default Icon;
